const buildLeasesDropdownOptions = (leases) =>
  leases.map((lease) => {
    return {
      value: lease.id,
      label: lease.title,
    };
  });

export default buildLeasesDropdownOptions;
